import {Component, OnInit} from '@angular/core';
import {UsuariosService} from "./usuarios.service";
import {UsuariosModel} from "./usuarios.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html'
})
export class UsuariosComponent extends Components implements OnInit {

  usuarios: UsuariosModel[] = [];
  listStatus = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private usuariosService: UsuariosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'usuarios'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {

    this.atualizaUsers();

    this.usuariosService.getListStatus()
      .subscribe(
        json => {
          this.listStatus = json.Payload;

          if (this.global.debug) {
            console.log(this.listStatus);
          }
        },
        error => {
          this.func.showErro(error.json());
        });

  }

  atualizaUsers(){
    this.carregandoTabela = true;

    this.usuariosService.getPaginacao(1,this.itensPorPagina, ['status', 'cargo'])
      .subscribe(data => {
        this.usuarios = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.usuarios);
        }
      },error => {
        this.trataErro(error.json());
        this.carregandoTabela = false;
      });
  }

  deleteUser(user) {
    let usuarios = this.usuarios;
    let usuariosService = this.usuariosService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarUsuario')+user.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(usuarios);
        }

        let index = usuarios.indexOf(user);
        usuarios.splice(index, 1);

        usuariosService.apagar(user.id_usuario)
          .subscribe(res => {
              //swal(this.func.traduzir('back.deletado'), this.func.traduzir('back.removidoComSucesso'), "success");
              self.usuarios = usuarios;
            },
            error => {
              //swal(this.func.traduzir('back.erro'), this.func.traduzir('back.registroNaoRemovido'), "error");
              // Revert the view back to its original state
              usuarios.splice(index, 0, user);
              self.usuarios = usuarios;
              usuariosService.trataErro(error.json());
            });
      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.usuariosService.getPaginacao(pagina,this.itensPorPagina, ['status', 'cargo'])
      .subscribe(data => {
        this.usuarios = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },error => {
        this.trataErro(error.json());
        this.carregandoTabela = false;
      });
  }

  solicitarNovaSenha(user){

    let usuariosService = this.usuariosService;

    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaSolicitarNovaSenha')+user.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){


        usuariosService.solicitarNovaSenha(user.email)
          .subscribe(res => {
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.emailEnviadoUsuario'), "success");
            },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.emailNaoEnviadoUsuario'), "error");

              self.func.showErro(error.json());
            });

      });

  }

  alteraStatus(id_usuario, id_status){

    let usuariosService = this.usuariosService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaAlterarStatus'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){

        usuariosService.setStatus(id_usuario, id_status)
          .subscribe(res => {
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");

              self.atualizaUsers();
            },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");

              self.func.showErro(error.json());
            });

      });
  }
}



// WEBPACK FOOTER //
// ./src/app/usuarios/usuarios.component.ts